import { connect } from 'react-redux';
import Curriculum from '../../components/curriculum/Curriculum';
import * as actions from '../../actions/schedule';

const mapStateToProps = ({ schedule }) => ({
  studyYear: schedule.studyYear,
  specialty: schedule.specialty,
  curriculum: schedule.curriculum,
});

const mapDispatchToProps = dispatch => ({
  didMount: () =>
    dispatch(actions.getSpecialty())
    && dispatch(actions.getYears()),
  getCurriculum: (yearId, specId) => dispatch(actions.getCurriculum(yearId, specId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Curriculum);
